import { Divider, Row, Space } from 'antd'
import Availability from 'app/components/Core/CategorySegment/Tag/Availability'
import KDateInfo from 'app/components/Modules/DataDisplay/KDateInfo'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import Detail from 'app/pages/Checkout/Component/SubItem/Detail'
import React, { ComponentProps, Fragment } from 'react'

import { CollectionProps } from '../convention'

type Props = ComponentProps<typeof Detail>['props']

const SubItemEditableList: React.FC<CollectionProps<ISubItem, Props>> = ({
  collection: subItems = [],
  props = {}
}) => {
  return (
    <If condition={subItems.length}>
      <Row gutter={[0, 12]}>
        {subItems.map((item) => (
          <Fragment key={item.id}>
            <KCol span={24}>
              <Detail
                member={item}
                props={{
                  description: (
                    <Space direction="vertical">
                      <KDateInfo dates={item} />
                      <Availability member={item} />
                    </Space>
                  ),
                  ...props
                }}
              />
            </KCol>
            <KCol span={24} className="divider">
              <Divider className="my-0" />
            </KCol>
          </Fragment>
        ))}
      </Row>
    </If>
  )
}

export default SubItemEditableList
